import React from 'react'

function DeadlineSettingsItemLayout({ children }: { children: JSX.Element | JSX.Element[] }) {
  return (
    <div className="flex flex-col">
      {children}
      <hr className="border-text-primary/15 mt-7 border-solid" />
    </div>
  )
}
export default DeadlineSettingsItemLayout
